import * as S from "./styles";

function Solicitada({corrida, track}) {

  return (
    <S.CenterSheet>
      <S.DetailBox>
        <S.Destaque>
          Corrida Solicitada!
        </S.Destaque>
        <S.PrimaryButton onClick={() => {
          track(corrida);
        }}>
          Acompanhar Corrida
        </S.PrimaryButton>
      </S.DetailBox>
    </S.CenterSheet>
  );
}
export default Solicitada;